import { useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import ReactDOM from "react-dom";

const useUniversalAssetPickerChange = (
  bubbles,
  changeUniversalAssetPicker,
  setUniversalAssetPicker,
  selectedAsset,
  changeCPlace,
  setCPlace,
  options,
  onOptionClick,
) => {
  useEffect(() => {
    if (!changeUniversalAssetPicker && !changeCPlace) return;

    const card = bubbles[bubbles.length - 1]?.querySelector(".ac-adaptiveCard");
    if (!card) return;

    const inputEl = card.querySelector("#asset input");
    if (!inputEl || inputEl.dataset.replaced) return;
    if (!options.length) return;

    // Hide original input
    inputEl.style.position = "absolute";
    inputEl.style.opacity = "0";
    inputEl.style.width = "0";
    inputEl.style.height = "0";
    inputEl.style.pointerEvents = "none";

    const container = document.createElement("div");
    container.classList.add("mui-autocomplete-container");
    inputEl.parentNode?.insertBefore(container, inputEl.nextSibling);

    // Controlled value for MUI Autocomplete
    let currentValue = inputEl.value || "";

    const handleInputChange = (_event, newInputValue) => {
      currentValue = newInputValue;

      inputEl.value = newInputValue;

      inputEl.dispatchEvent(new Event("input", { bubbles: true }));
      inputEl.dispatchEvent(new Event("change", { bubbles: true }));

      const muiInput = container.querySelector("input");
      if (muiInput) {
        muiInput.dataset.hasValue = !!newInputValue;
        muiInput.dispatchEvent(
          new CustomEvent("autocompleteChange", {
            bubbles: true,
            composed: true,
          }),
        );
      }
    };

    const handleChange = (_event, value, reason) => {
      const selectedValue = Array.isArray(value) ? value[0] : value || "";

      if (reason === "selectOption" && onOptionClick) {
        onOptionClick(selectedValue);
      }

      currentValue = selectedValue;
      inputEl.value = selectedValue;
      inputEl.dispatchEvent(new Event("input", { bubbles: true }));
      inputEl.dispatchEvent(new Event("change", { bubbles: true }));
    };

    ReactDOM.render(
      <Autocomplete
        options={options}
        freeSolo
        value={currentValue}
        onChange={handleChange}
        onInputChange={handleInputChange}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{ width: "100%" }}
            onBlur={() => {
              const trimmed = currentValue.trim();
              if (currentValue !== "" && trimmed === "") {
                currentValue = "";
                inputEl.value = "";
                inputEl.dispatchEvent(new Event("input", { bubbles: true }));
                inputEl.dispatchEvent(new Event("change", { bubbles: true }));

                params.inputProps?.setCustomValidity?.(
                  "Must contain at least one non-space character",
                );
                params.inputProps?.reportValidity?.();
              } else {
                params.inputProps?.setCustomValidity?.("");
              }
            }}
          />
        )}
      />,
      container,
    );

    inputEl.dataset.replaced = "true";
    setUniversalAssetPicker(false);
    setCPlace(false);
  }, [bubbles.length, changeUniversalAssetPicker, selectedAsset, changeCPlace]);
};
export default useUniversalAssetPickerChange;
